import { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { BsSearch } from 'react-icons/bs';

import TextInput from '#globalComponents/Forms/TextInput';

export default function SearchBar({ value, onChange, placeholder = 'Unternehmen suchen...', className = '' }) {
	const [inputValue, setInputValue] = useState(value || '');

	// Debounce the search to avoid too many API calls
	useEffect(() => {
		const timer = setTimeout(() => {
			if (inputValue !== value) {
				onChange(inputValue);
			}
		}, 500);

		return () => clearTimeout(timer);
	}, [inputValue, value, onChange]);

	// Update input when external value changes
	// inputValue is intentionally excluded to avoid infinite loops — this effect
	// only syncs the external `value` prop into local state
	useEffect(() => {
		setInputValue(value || '');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	return (
		<div className={`relative ${className}`}>
			{/* Search Icon */}
			<div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-bgBase-800">
				<BsSearch className="w-5 h-5" />
			</div>

			{/* Search Input */}
			<TextInput
				value={inputValue}
				onChange={(e) => setInputValue(e.target.value)}
				placeholder={placeholder}
				className="pr-12"
			/>
		</div>
	);
}

SearchBar.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onClear: PropTypes.func,
	placeholder: PropTypes.string,
	className: PropTypes.string,
};
